import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../service/dashboard.service';
import { ComplaintsService } from '../../service/complaints.service'
import Swal from 'sweetalert2';
import { DepartmentService } from '../../service/department.service'
import { session } from '../../../../environments/environment.session';
import { SpinnerService } from '../../../shared/spinner.service'
import { AreaMapService } from '../../service/area-map.service'

// interface Complaint {
//   id: number;
//   dept: string;
//   zone: string;
//   status: string;
//   create_date: string;
//   number_of_open_days: number;
// }
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  // Dropdown data
  dropdownOptions: any = {
    dept: [],
    zone: [],
    status: [],
    create_date: []
  };

  statusArr = [{ code: 'PENDING', value: 'PENDING' },
  { code: 'RESOLVED', value: 'RESOLVED' },
  { code: 'CLOSED', value: 'CLOSED' },

  ]
  // Selected filter values
  selectedDepartment: string | null = null;
  selectedZone: string | null = null;
  selectedStatus: string | null = null;
  selectedcreate_date: string | null = null;

  // Complaint data and metrics
  complaints: any[] = [];
  filteredComplaints: any[] = [];

  totalComplaints: number = 0;
  pendingCount: number = 0;
  pendingPercentage: any = 0;
  resolvedCount: number = 0;
  resolvedPercentage: any = 0;
  closedCount: number = 0;
  closedPercentage: any = 0;
  //   slaBreachCount: number = 0;
  // slaBreachPercentage: number = 0;
  // Pagination config
  currentPage = 1;
  pageSize = 5;
  totalRecords = 0;
  totalPages = 0;
  pages: (number | string)[] = [];
  page_list = [5, 10, 20, 50, 100];
  pagedComplaints: any[] = [];
  escalatedCount:  number = 0;
  escalatedPercentage: any = 0;
  constructor(private depS: DepartmentService, private areaMapService: AreaMapService, private dashS: DashboardService, private cs: ComplaintsService, private tspinner: SpinnerService) { }
  erpUser: any

  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser))
    // this.loadDropdownData();
    // await this.getArea();
    await this.getDepartment();
    await this.getComplaints();
    this.applyFilters();
    let obj = { b_acct_id: this.erpUser.b_acct_id ,user_id:this.erpUser.le_id }
    let resp = await this.dashS.getallComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      console.log(resp['data'])
      this.totalComplaints = resp['data']['total_complaints']
      this.pendingCount = resp['data']['pending_complaints']
      this.resolvedCount = resp['data']['total_resolved']
      this.closedCount = resp['data']['total_closed']
      this.escalatedCount=resp['data']['total_escalated']
 
       this.pendingPercentage=(this.pendingCount *100/this.totalComplaints).toFixed(0);
 
     
     this.resolvedPercentage=(this.resolvedCount *100/this.totalComplaints).toFixed(0);

     this.closedPercentage=(this.closedCount *100/this.totalComplaints).toFixed(0);
          this.escalatedPercentage=(this.escalatedCount *100/this.totalComplaints).toFixed(0);


    } else {

    }
    console.log(resp);
  }


  allDepartment: any = []
  async getDepartment() {
    let obj = { b_acct_id: this.erpUser.b_acct_id };
    let resp = await this.depS.getDepartment(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.allDepartment = resp['data']
    } else {
      Swal.fire('Opps !!', resp['data'], 'error')
      return
    }
  }
  getDepartmentName(deptId: number): string {
    const dept = this.allDepartment.find((d: any) => d.dep_id === deptId);
    return dept ? dept.department_name : " ";
  }
  // allArea: any = []
  // async getAreaMapData() {
  //   let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id })
  //   if (resp['error'] == false) { 
  //     this.allArea = resp['data'];
  //     console.log(this.allArea);
  //   }
  // }




  // zoneLeafCode: any = {}
  // async getArea() {
  //   let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id })
  //   if (resp['error'] == false) {
  //     let temp: any = []
  //     this.zoneArr = []
  //     this.wordArr = []
  //     this.allArea = resp['data']
  //     this.allArea.map((x: any) => {
  //       if (!temp.includes(x['zone_cd'])) {
  //         this.zoneArr.push(x);
  //         this.zoneLeafCode[x['zone_cd']] = x
  //         temp.push(x['zone_cd'])
  //       }
  //       this.wordCodeObj[x['word'].trim()] = x
  //       this.allAreaObj[x['id']] = x

  //       if (this.zoneWordMohallaObj[x['zone_cd']]) {
  //         if (this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()]) {
  //           this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
  //         } else {
  //           this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()] = []
  //           this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
  //         }
  //       } else {
  //         this.zoneWordMohallaObj[x['zone_cd']] = {}
  //         this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()] = []
  //         this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
  //       }
  //     })
  //     console.log(this.zoneArr)
  //     this.tspinner.hide()
  //   }
  // }
  // zoneArr: any = []
  // async getArea() {
  //   let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id })
  //   console.log(resp)
  //   if (resp['error'] == false) {
  //     let temp: any = []
  //     this.zoneArr = []
  //     resp['data'].map((x: any) => {
  //       if (!temp.includes(x['zone_cd'])) {
  //         this.zoneArr.push(x);
  //         temp.push(x['zone_cd'])
  //       }
  //     })

  //     console.log(this.zoneArr)
  //   }
  // }
  availableCreateDates: any = [];
  allZones: any = [];
  async getComplaints() {

    let obj = { b_acct_id: this.erpUser.b_acct_id ,user_id:this.erpUser.le_id };
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] === false) {
      this.complaints = resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));


        } catch (err) {
          complaint.departments = [];
        }
        // complaint.create_date_only = complaint.create_date
        //   ? complaint.create_date.split(' ')[0]
        //   : null;
        // if (complaint.create_date_only) {
        //   const [dd, mm, yyyy] = complaint.create_date_only.split('-');
        //   complaint.create_date_ymd = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
        // } else {
        //   complaint.create_date_ymd = null;
        // }
        return complaint;
      });
      this.totalComplaints = this.complaints.length;
      this.availableCreateDates = [
        ...new Set(this.complaints.map(comp => comp.create_date))
      ];
      this.allZones = [
        ...new Set(this.complaints.map(comp => comp.zone))
      ];


      console.log(this.complaints);
    } else {
      Swal.fire('Oops !!', resp['data'], 'error');
      return;
    }

    this.tspinner.hide();
  }

  onFilterChange(): void {
    this.applyFilters();
    this.currentPage = 1;
    this.updatePagedData();
    this.updatePages();
  }


  loadComplaints(): void {
    this.complaints = [
      { id: 101, department: 'Electrical', zone: 'North Zone', status: 'Pending', created: '2024-06-01', daysOpen: 25 },
    ];

    this.totalComplaints = this.complaints.length;
    // this.calculateMetrics();
  }
  applyFilters(): void {
    // console.log("Selected Date:", this.selectedcreate_date);

    this.filteredComplaints = this.complaints.filter(comp =>
      (!this.selectedDepartment || comp.departments.flat().includes(this.selectedDepartment)) &&

      (!this.selectedZone || comp.zone === this.selectedZone) &&

      (!this.selectedStatus || comp.status === this.selectedStatus) &&
      (!this.selectedcreate_date || comp.create_date === this.selectedcreate_date)
    );

    this.totalRecords = this.filteredComplaints.length;
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
    this.currentPage = 1;

    this.updatePagedData();
    this.updatePages();
  }


  clearFilter(): void {
    this.selectedDepartment = null;
    this.selectedZone = null;
    this.selectedStatus = null;
    this.selectedcreate_date = null;
    this.applyFilters();
  }

  // calculateMetrics(): void {
  //   this.pendingCount = this.complaints.filter(c => c.status === 'Pending').length;
  //   this.resolvedCount = this.complaints.filter(c => c.status === 'Resolved').length;
  // this.closedCount = this.complaints.filter(c => c.status === 'Closed').length;        // 🔵 ADDED
  // this.closedPercentage = this.totalComplaints ? Math.round((this.closedCount / this.totalComplaints) * 100) : 0;   // 🔵 ADDED
  // this.slaBreachCount = this.complaints.filter(c => c.daysOpen > 15).length;
  // this.slaBreachPercentage = this.totalComplaints ? Math.round((this.slaBreachCount / this.totalComplaints) * 100) : 0;

  //   this.pendingPercentage = this.totalComplaints ? Math.round((this.pendingCount / this.totalComplaints) * 100) : 0;
  //   this.resolvedPercentage = this.totalComplaints ? Math.round((this.resolvedCount / this.totalComplaints) * 100) : 0;
  // }

  // Pagination handlers

  updatePagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedComplaints = this.filteredComplaints.slice(start, end);
  }

  updatePages(): void {
    const pages: (number | string)[] = [];
    this.totalPages = Math.ceil(this.filteredComplaints.length / this.pageSize);

    if (this.totalPages <= 7) {
      for (let i = 1; i <= this.totalPages; i++) pages.push(i);
    } else {
      if (this.currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, '...', this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        pages.push(1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages);
      } else {
        pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages);
      }
    }
    this.pages = pages;
  }

  goToPage(page: number | string): void {
    if (typeof page !== 'number' || page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePagedData();
    this.updatePages();
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
      this.updatePages();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
      this.updatePages();
    }
  }

  changePageSize(): void {
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.filteredComplaints.length / this.pageSize);
    this.updatePagedData();
    this.updatePages();
  }

}
